/**
 * Shared configuration for Netlify functions (ESM).
 * Keep in sync with shared-config.ts.
 */

export const FIRESTORE_ARTIFACTS_APP_ID = "lorena-cleaning";
export const FIRESTORE_ARTIFACTS_PROFILE_DOC_ID = "default";

export const COLLECTIONS = {
  USERS: "users",
  BOOKINGS: "bookings",
  BOOKING_REQUESTS: "booking_requests",
  BLOCKED_DAYS: "blockedDays",
  ARTIFACTS: "artifacts",
  PROFILE: "profile",
  INQUIRIES: "inquiries",
  PAYMENTS: "payments",
  /** Token docs for optional email verification flows (auth function). */
  EMAIL_VERIFICATIONS: "email_verifications",
  /** Stripe webhook error telemetry (single doc: stripe_webhook_last_error). */
  SYSTEM_METRICS: "system_metrics",
  /** Dedupe claims for day-before SMS reminders — prevents double-send on cron retry. */
  SMS_REMINDERS: "sms_reminders",
  /** Dedupe claims for post-completion review request SMS. */
  REVIEW_SMS_CLAIMS: "review_sms_claims",
};

/** Subcollection segment names under a parent document. */
export const SUBCOLLECTIONS = {
  BOOKING_ACTIVITY: "activity",
};

export const DOC_IDS = {
  BLOCKED_DAYS_DEFAULT: "default",
};

export const paths = {
  userProfile: (uid) =>
    `${COLLECTIONS.ARTIFACTS}/${FIRESTORE_ARTIFACTS_APP_ID}/${COLLECTIONS.USERS}/${uid}/${COLLECTIONS.PROFILE}/${FIRESTORE_ARTIFACTS_PROFILE_DOC_ID}`,
  userParent: (uid) =>
    `${COLLECTIONS.ARTIFACTS}/${FIRESTORE_ARTIFACTS_APP_ID}/${COLLECTIONS.USERS}/${uid}`,
};
